import * as React from 'react'
import * as CollapsiblePrimitive from '@radix-ui/react-collapsible'
import { cn } from '@/lib/utils'

/**
 * Figma (node 18597:96515 — Collapsible):
 * Container: flex flex-col gap-2 (8px) items-start
 * Trigger row: flex items-center justify-between px-4 (16px)
 *   Title: text-sm font-semibold leading-5 text-foreground
 *   Toggle: ghost button, size-8, rounded-md, ChevronsUpDown icon size-4
 * Content: animated height transition on open/close
 */

export interface IntuiCollapsibleProps
  extends React.ComponentPropsWithoutRef<typeof CollapsiblePrimitive.Root> {}

const IntuiCollapsible = React.forwardRef<
  React.ComponentRef<typeof CollapsiblePrimitive.Root>,
  IntuiCollapsibleProps
>(({ className, ...props }, ref) => (
  <CollapsiblePrimitive.Root
    ref={ref}
    className={cn('flex flex-col gap-2', className)}
    {...props}
  />
))
IntuiCollapsible.displayName = 'IntuiCollapsible'

export type IntuiCollapsibleTriggerProps = React.ComponentPropsWithoutRef<
  typeof CollapsiblePrimitive.Trigger
>

const IntuiCollapsibleTrigger = CollapsiblePrimitive.Trigger
IntuiCollapsibleTrigger.displayName = 'IntuiCollapsibleTrigger'

export interface IntuiCollapsibleContentProps
  extends React.ComponentPropsWithoutRef<typeof CollapsiblePrimitive.Content> {}

const IntuiCollapsibleContent = React.forwardRef<
  React.ComponentRef<typeof CollapsiblePrimitive.Content>,
  IntuiCollapsibleContentProps
>(({ className, ...props }, ref) => (
  <CollapsiblePrimitive.Content
    ref={ref}
    className={cn(
      'overflow-hidden',
      'data-[state=open]:animate-collapsible-down',
      'data-[state=closed]:animate-collapsible-up',
      className
    )}
    {...props}
  />
))
IntuiCollapsibleContent.displayName = 'IntuiCollapsibleContent'

export { IntuiCollapsible, IntuiCollapsibleTrigger, IntuiCollapsibleContent }
